import { render, staticRenderFns } from "./DeleteEmailWarning.vue?vue&type=template&id=15634abc"
import script from "./DeleteEmailWarning.vue?vue&type=script&lang=js"
export * from "./DeleteEmailWarning.vue?vue&type=script&lang=js"
import style0 from "./DeleteEmailWarning.vue?vue&type=style&index=0&id=15634abc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports